import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {StoryComponent} from './story/story.component';

const routes: Routes = [
  {path: 'home', component: HomeComponent},
  {path: 'story/:releaseNo', component: StoryComponent},
  {path: '**', redirectTo: 'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
